export const EMAIL_REGEXP = /^[\w!#$%&'*+\-/=?^_`{|}~]+(\.[\w!#$%&'*+\-/=?^_`{|}~]+)*@(([-\w]+\.)+(?!ru$)[a-zA-Z]{2,63})$/i;
export const PASSWORD_REGEXP  = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-={}[\]:;"'|,.<>?/~`]{8,}$/;

;